import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { apiRequest } from '../../../../../Services/Common/ApiRequest';
import Global from '../../../../../Services/Common/Global';
import { mapParamsBySchema } from '../../../../../util';
import { MAI_BASIC_Schema } from './MAI_BASIC_Schema';
import { handleQuerySuccess } from '../../../../../hooks/useQuriesSuccess';
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(MAI_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Dashboard', 'getMaiBasicR1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Dashboard.getMaiBasicR1, params),
    enabled: true, // 자동 실행 여부
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
